import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e86f36a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "terminal-wrap"
}
const _hoisted_2 = { class: "left-wrap" }
const _hoisted_3 = { class: "right-wrap" }
const _hoisted_4 = { class: "filter-row" }
const _hoisted_5 = {
  style: {"display":"flex"},
  class: "cm-ui-mr10"
}
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "selection-bar" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_BaseTree = _resolveComponent("BaseTree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "terminal-select-wrap terminal-select-dialog",
    title: _ctx.displayTitle,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "70%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "top", {}, undefined, true),
      _createVNode(_component_el_tabs, {
        class: "content-adapt",
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            lazy: "",
            label: _ctx.$t('terminalAuth.tabAuthorized'),
            name: "authorizedView"
          }, null, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            lazy: "",
            label: _ctx.$t('terminalAuth.tabUnauthorized'),
            name: "unauthorizedView"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_BaseTree, {
                dataApi: "/terminal-group/team-list-auth",
                onTerminalGroupSelected: _ctx.terminalGroupSelected,
                "terminal-type": _ctx.terminalType,
                "custom-api-params": {
            permission_names: _ctx.permissionNames,
            is_auth: _ctx.isAuthorizedView,
          }
              }, null, 8, ["onTerminalGroupSelected", "terminal-type", "custom-api-params"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    disabled: !_ctx.selectionData.length && !_ctx.isSelectAll,
                    type: "primary",
                    onClick: _ctx.handleBatchOperate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isAuthorizedView ? _ctx.$t('terminalAuth.batchCancel') : _ctx.$t('terminalAuth.batchAdd')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_input, {
                    style: {"min-width":"280px"},
                    size: "small",
                    modelValue: _ctx.searchParams.searchKey,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.searchKey) = $event)),
                    placeholder: _ctx.$t('common.phMacFull'),
                    onChange: _ctx.handleSearch,
                    "suffix-icon": "el-icon-search"
                  }, null, 8, ["modelValue", "placeholder", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
                _createVNode(_component_el_button, {
                  type: "text",
                  disabled: !_ctx.pagination.total || _ctx.isSelectAll,
                  onClick: _ctx.handleSelectAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('terminalAuth.selectAllInGroup')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  disabled: !_ctx.selectedCount,
                  onClick: _ctx.handleCancelSelect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('terminalAuth.cancelSelect')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  disabled: !_ctx.selectedCount,
                  onClick: _ctx.toggleShowSelected
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isShowSelection ? _ctx.$t('terminalAuth.close') : _ctx.$t('terminalAuth.view')) + _toDisplayString(_ctx.$t('terminalAuth.selectedSuffix', { count: _ctx.selectedCount })), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "empty-text": _ctx.$t('common.noData'),
                ref: "tableNode",
                data: _ctx.tableData,
                width: "100%",
                height: "100%",
                "row-key": "device_id",
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    "reserve-selection": "",
                    width: "50",
                    selectable: () => !_ctx.isSelectAll
                  }, null, 8, ["selectable"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('terminalAuth.colComputerName'),
                    prop: "computer_name",
                    "min-width": "200"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "user_mark",
                    label: _ctx.$t('terminalAuth.colUserMark'),
                    "min-width": "200",
                    "show-overflow-tooltip": ""
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "system_name",
                    label: _ctx.$t('terminalAuth.colOs'),
                    "min-width": "200"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "system_ip",
                    label: _ctx.$t('terminalAuth.colIp'),
                    "min-width": "200"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_IPColumn, {
                        cip: scope.row.client_ip,
                        sip: scope.row.system_ip
                      }, null, 8, ["cip", "sip"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "mac",
                    label: _ctx.$t('terminalAuth.colMac'),
                    "min-width": "170",
                    "show-overflow-tooltip": "",
                    "tooltip-effect": "light"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "group_name",
                    label: _ctx.$t('terminalAuth.colAction'),
                    "min-width": "70",
                    fixed: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: "cm-link-light",
                        onClick: ($event: any) => (_ctx.handleItemAuth(scope.row))
                      }, _toDisplayString(_ctx.isAuthorizedView ? _ctx.$t('terminalAuth.cancelConfig') : _ctx.$t('terminalAuth.addConfig')), 9, _hoisted_8)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["empty-text", "data", "onSelectionChange"])), [
                [_directive_loading, _ctx.isLoading]
              ]),
              _createVNode(_component_el_pagination, {
                background: "",
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange,
                "current-page": _ctx.pagination.currentPage,
                "page-sizes": [10, 20, 30, 50, 100],
                "page-size": _ctx.pagination.pageSize,
                total: _ctx.pagination.total,
                layout: "total, sizes, prev, pager, next, jumper",
                style: {"text-align":"right","padding-top":"20px"}
              }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["title", "model-value", "onClose"]))
}